<!-- InstallButton.vue -->
<template>
  <!-- <div>
    <button v-if="showButton" 
      @click="installPWA">Install App</button>
  </div> -->
  <div v-if="showInstallBanner" 
    class="pwa-banner">
    <div class="banner-content">
      <span class="banner-text">Get our free app. It won't take up space on your phone.</span>
      <button @click="installPWA" 
        class="install-button">Install</button>
      <button @click="dismissBanner" 
        class="close-button" 
        aria-label="Dismiss">
        <span class="icon">
          <i class="mdi mdi-close mdi-18px" />
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      deferredPrompt: null,
      showInstallBanner: false
    }
  },
  created() {},
  mounted() {
    window.addEventListener('beforeinstallprompt', (e) => {
      console.log(`window.beforeinstallprompt: ${e}`)
      e.preventDefault()
      this.deferredPrompt = e
      this.showInstallBanner = true
      document.body.style.paddingTop = '50px'
    })
  },
  methods: {
    installPWA() {
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt()
        this.deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt')
          } else {
            console.log('User dismissed the A2HS prompt')
          }
          this.deferredPrompt = null
          this.showInstallBanner = false
        })
      }
    },
    dismissBanner() {
      this.showInstallBanner = false
      document.body.style.paddingTop = null // Reset padding
    }
  }
}
</script>

<style>
.pwa-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #3273dc;
  color: white;
  padding: 12px 20px;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-content {
  display: flex;
  align-items: center;
  max-width: 1200px;
  width: 100%;
  justify-content: space-between;
}

.banner-text {
  flex-grow: 1;
  margin-right: 20px;
  font-size: 14px;
}

.install-button {
  background: white;
  color: #3273dc;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  margin-right: 10px;
  transition: background 0.2s;
}

.install-button:hover {
  background: #f0f0f0;
}

.close-button {
  background: transparent;
  color: white;
  border: none;
  font-size: 20px;
  cursor: pointer;
  padding: 0 5px;
  line-height: 1;
}

.close-button:hover {
  opacity: 0.8;
}
</style>